enum PermissionType {
  NOT_DEFINED = '',
  MENU = 'menu',
  ACTION = 'action',
}

export default PermissionType;
